var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsHamburger(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 3,
    fill: "#575a83"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 3,
    fill: "#575a83"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 3,
    fill: "#575a83"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 23,
    height: 3,
    fill: "#575a83"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 23,
    height: 3,
    fill: "#575a83"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 23,
    height: 3,
    fill: "#575a83"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 23,
    height: 3,
    fill: "#575a83"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 23,
    height: 3,
    fill: "#575a83"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 23,
    height: 3,
    fill: "#575a83"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsHamburger);
export default __webpack_public_path__ + "static/assets/settings-hamburger.svg";
export { ForwardRef as ReactComponent };